import * as apigw from "./apigw"

export const contact = async (
    title: string,
    text: string,
    email: string,
    name: string,
    opts?: any) => {

    const res = await apigw.noauthRequest(
        "/system/contact",
        { title, text, email, name },
        opts
    );
    return res;
};
